/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface CheckPaymentRequired200ResponseData
 */
export interface CheckPaymentRequired200ResponseData {
  /**
   * Оплата пошлины доступна (статус заявки и опции позволяют)
   * @type {boolean}
   * @memberof CheckPaymentRequired200ResponseData
   */
  paymentAllowed: boolean
}

/**
 * Check if a given object implements the CheckPaymentRequired200ResponseData interface.
 */
export function instanceOfCheckPaymentRequired200ResponseData(
  value: object
): value is CheckPaymentRequired200ResponseData {
  if (!('paymentAllowed' in value) || value['paymentAllowed'] === undefined)
    return false
  return true
}

export function CheckPaymentRequired200ResponseDataFromJSON(
  json: any
): CheckPaymentRequired200ResponseData {
  return CheckPaymentRequired200ResponseDataFromJSONTyped(json, false)
}

export function CheckPaymentRequired200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): CheckPaymentRequired200ResponseData {
  if (json == null) {
    return json
  }
  return {
    paymentAllowed: json['paymentAllowed'],
  }
}

export function CheckPaymentRequired200ResponseDataToJSON(
  value?: CheckPaymentRequired200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    paymentAllowed: value['paymentAllowed'],
  }
}
